// eslint-disable-next-line
export const CLIENT_USER_AUTHENTICATED = 'client_user_authenticated';